// extracted by mini-css-extract-plugin
module.exports = {"edit":"AbsencesPlanningModal_edit__2EDs5","delete":"AbsencesPlanningModal_delete__11ZI9","container":"AbsencesPlanningModal_container__2MyoZ"};